import { Button } from "@replicate/ui";
import { Suspense, lazy, useMemo } from "react";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

const LazyPDFRenderer = lazy(() => import("./pdf-renderer"));

export function PDFPreview({ value }: { value: string }) {
  const downloadCta = useMemo(() => {
    // Not much sense in downloading a blob URL,
    // since it's already on your file system.
    if (value.startsWith("blob")) return null;

    let isUrl = false;
    try {
      new URL(value);
      isUrl = true;
    } catch (e) {
      isUrl = false;
    }
    if (!isUrl) return null;
    return (
      <Button
        className="!bg-black !text-white"
        onClick={(e) => {
          // Prevents shenanigans if this is rendered in a Dropzone.
          e.stopPropagation();
        }}
        // biome-ignore lint/a11y/useAnchorContent: Content is injected
        render={<a href={value} target="_blank" download rel="noreferrer" />}
        variant="outlined"
        size="xs"
      >
        Download PDF
      </Button>
    );
  }, [value]);

  return (
    <div className="flex items-center justify-center gap-2 border min-h-48 relative">
      <div className="w-full h-80">
        <Suspense fallback={null}>
          <LazyPDFRenderer key={value} url={value} />
        </Suspense>
      </div>

      {downloadCta ? (
        <div className="absolute bottom-2 right-2 z-10">{downloadCta}</div>
      ) : null}
    </div>
  );
}
